function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { FormPath, onFieldChange } from '@formily/core';
import { observer, useField, useForm, useFormEffects } from '@formily/react';
import { autorun, untracked } from '@formily/reactive';
import React, { useContext, useEffect, useRef } from 'react';
import { Scope, evalStatement } from '@micun/form-expression';
import { ScopeContext } from '@micun/form-expression/react/index';
import { useUpdate } from "./useUpdate";
import { getType } from "../utils";
export var usePlaceholder = function usePlaceholder() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请选择';
  var field = useField();
  return "".concat(prefix).concat(field.title);
};
export var useClear = function useClear(fields) {
  var form = useForm();
  var field = useField();
  return function () {
    fields.forEach(function (dest) {
      var path = FormPath.parse(dest, field.path);
      form.setFieldState(path, function (target) {
        target.onInput(undefined);
      });
      form.setValuesIn(path, undefined);
    });
  };
};
export var useFill = function useFill(fields) {
  var form = useForm();
  var field = useField();
  return function (result) {
    fields.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        dest = _ref2[0],
        src = _ref2[1];
      var value = src;
      if (typeof value === 'string' && value[0] === '$') {
        value = FormPath.getIn(result, src.slice(1));
      }
      var path = FormPath.parse(dest, field.path);
      form.setFieldState(path, function (field) {
        field.onInput(value);
      });
      form.setValuesIn(path, value);
    });
  };
};
export var useValues = function useValues(valueMap) {
  var form = useForm();
  var field = useField();
  var _useContext = useContext(ScopeContext),
    scope = _useContext.scope;
  var nextScope = new Scope({
    context: form.values,
    parent: scope
  });
  return Object.keys(valueMap).reduce(function (map, dest) {
    var src = valueMap[dest];
    var value = src;
    if (typeof value === 'string' && value[0] === '$') {
      var path = FormPath.parse(src.slice(1), field.path);
      value = nextScope.get(path.toString());
    }
    map[dest] = value;
    return map;
  }, {});
};
export var useParams = function useParams(depends) {
  var form = useForm();
  var forceUpdate = useUpdate();
  var field = useField();
  var _useContext2 = useContext(ScopeContext),
    scope = _useContext2.scope;
  var nextScope = new Scope({
    context: form.values,
    parent: scope
  });
  var getValue = function getValue(value) {
    var depends = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var valueType = getType(value);
    switch (valueType) {
      case 'Object':
        if (value !== null) {
          return Object.keys(value).reduce(function (map, key) {
            map[key] = getValue(value[key], depends);
            return map;
          }, {});
        }
        break;
      case 'Array':
        return value.map(function (i) {
          return getValue(i, depends);
        });
      case 'String':
        if (value[0] === '$') {
          var valuePath = value.slice(1);
          var path = FormPath.parse(valuePath, field.path);
          depends.push(path.toString());
          return nextScope.get(valuePath);
        }
    }
    return value;
  };
  useFormEffects(function () {
    var reactionFields = [];
    getValue(depends, reactionFields);
    reactionFields.forEach(function (fieldName) {
      onFieldChange(fieldName, function () {
        // console.log('useParams params force update', fieldName, field)
        forceUpdate();
      });
    });
  });
  return function () {
    return getValue(depends);
  };
};
/**
 * 通用表达式计算，可以用于被动或者主动控制其他字段行为
 * @param reaction
 */
export var useReaction = function useReaction(reaction) {
  var form = useForm();
  var field = useField();
  var _useContext3 = useContext(ScopeContext),
    scope = _useContext3.scope;
  var deposes = useRef([]).current;
  var getFieldMap = useFieldMap();
  useEffect(function () {
    var id = '' + Math.random() + Math.random();
    // console.log('useReaction', reaction, field, form, id)
    var onReaction = function onReaction() {
      if (reaction) {
        if (!Array.isArray(reaction)) {
          reaction = [reaction];
        }
        reaction.forEach(function (item) {
          var target = item.target,
            depends = item.depends,
            _item$state = item.state,
            state = _item$state === void 0 ? {} : _item$state,
            track = item.track,
            mode = item.mode;
          // console.log('onFieldChange', target, state)
          var relativePath = mode === 'field' ? field.address : field.path;

          // 自身联动控制其他字段
          var targetReaction = function targetReaction() {
            var targetFieldPath = '';
            if (Array.isArray(target)) {
              var absolutePath = toAbsPath(target, relativePath);
              targetFieldPath = "*(".concat(absolutePath.join(','), ")");
            } else {
              targetFieldPath = FormPath.parse(target, relativePath).toString();
            }
            var onReaction = function onReaction() {
              // console.log('onFormReact onReaction', track)
              var evalOption;
              untracked(function () {
                if (mode === 'field') {
                  var fieldMap = getFieldMap();
                  evalOption = {
                    context: _objectSpread(_objectSpread({}, fieldMap), {}, {
                      self: field,
                      __base__: field.path.toString()
                    }),
                    parentScope: scope
                  };
                } else {
                  evalOption = {
                    context: _objectSpread(_objectSpread({}, form.values), {}, {
                      self: field.value,
                      __base__: field.path.toString()
                    }),
                    parentScope: scope
                  };
                }
              });
              var nextState = Object.keys(state).reduce(function (map, key) {
                var expr = state[key];
                var result = evalStatement(Array.isArray(expr) ? expr : [expr], evalOption);
                map[key] = result;
                return map;
              }, {});
              form.setFieldState(targetFieldPath, function (targetState) {
                Object.keys(nextState).forEach(function (key) {
                  FormPath.setIn(targetState, key, nextState[key]);
                });
              });
            };
            if (track) {
              deposes.push(autorun(onReaction));
            } else {
              onFieldChange(field.path, onReaction);
              onReaction();
            }
          };

          // 依赖项联动控制自身或指定字段
          var dependsReaction = function dependsReaction() {
            var dependsPath = Array.isArray(depends) ? depends : [depends];
            var targetsPath = [];
            if (target) {
              targetsPath = Array.isArray(target) ? target : [target];
              targetsPath = toAbsPath(targetsPath, relativePath);
            }
            dependsPath = toAbsPath(dependsPath, relativePath);
            var onReaction = function onReaction() {
              var evalOption;
              untracked(function () {
                if (mode === 'field') {
                  var fieldMap = getFieldMap();
                  var deps = dependsPath.map(function (path) {
                    return fieldMap[path];
                  });
                  evalOption = {
                    context: _objectSpread(_objectSpread({}, fieldMap), {}, {
                      self: field,
                      deps: deps,
                      __base__: relativePath.toString()
                    }),
                    parentScope: scope
                  };
                } else {
                  var _deps = dependsPath.map(function (path) {
                    return form.getValuesIn(path);
                  });
                  evalOption = {
                    context: _objectSpread(_objectSpread({}, form.values), {}, {
                      self: field.value,
                      deps: _deps,
                      __base__: relativePath.toString()
                    }),
                    parentScope: scope
                  };
                }
              });
              Object.keys(state).forEach(function (key) {
                var expr = state[key];
                var result = evalStatement(Array.isArray(expr) ? expr : [expr], evalOption);
                if (targetsPath.length) {
                  form.setFieldState("*(".concat(targetsPath.join(','), ")"), function (state) {
                    FormPath.setIn(state, key, result);
                  });
                } else {
                  field.setState(function (state) {
                    FormPath.setIn(state, key, result);
                  });
                }
              });
            };
            onFieldChange("*(".concat(dependsPath.join(','), ")"), onReaction);
            onReaction();
          };
          if (target && depends) {
            dependsReaction();
          } else if (target) {
            targetReaction();
          } else if (depends) {
            dependsReaction();
          }
        });
      }
    };
    form.addEffects(id, onReaction);
    return function () {
      deposes.forEach(function (i) {
        return i();
      });
      deposes.length = 0;
      form.removeEffects(id);
    };
  }, [field, form]);
};
export var wrapReactionHook = function wrapReactionHook(Component, option) {
  var Wrapper = observer(Component, option);
  return observer(function (props, ref) {
    var _ref3 = props,
      _ref3$reaction = _ref3.reaction,
      reaction = _ref3$reaction === void 0 ? [] : _ref3$reaction;
    useReaction(reaction);
    if (option !== null && option !== void 0 && option.forwardRef) {
      return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
        ref: ref
      }));
    }
    return /*#__PURE__*/React.createElement(Wrapper, props);
  }, option);
};
export var useFieldMap = function useFieldMap() {
  var form = useForm();
  return function () {
    return Object.keys(form.fields).reduce(function (map, fieldName) {
      var currentField = form.fields[fieldName];
      map[currentField.path.toString()] = currentField;
      return map;
    }, {});
  };
};
var _get = function _get(source, path) {
  var paths = path.replace(/\[(\d+)\]/g, '.$1').split('.');
  var result = source;
  var _iterator = _createForOfIteratorHelper(paths),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      result = Object(result)[p];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var _set = function _set(obj, path, value) {
  var parts = path.split('.');
  parts.reduce(function (acc, cur, idx) {
    if (!acc[cur]) {
      acc[cur] = {};
    }
    if (idx === parts.length - 1) {
      acc[cur] = value;
    }
    return acc[cur];
  }, obj);
};
export var useMultiMap = function useMultiMap(values, valueMap) {
  return Object.keys(valueMap).reduce(function (values, fieldName) {
    var valueName = valueMap[fieldName];
    values.forEach(function (value) {
      _set(value, fieldName, _get(value, valueName.replace('$', '')));
    });
    return values;
  }, values);
};
export var useMultiFill = function useMultiFill(values) {
  var autoFill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return autoFill.reduce(function (values, fill) {
    var _ref4 = fill || [],
      _ref5 = _slicedToArray(_ref4, 2),
      fieldName = _ref5[0],
      valueName = _ref5[1];
    values.forEach(function (value) {
      _set(value, fieldName, _get(value, valueName.replace('$', '')));
    });
    return values;
  }, values);
};
export var toAbsPath = function toAbsPath(path, base) {
  return path.map(function (p) {
    return FormPath.parse(p, base).toString();
  });
};